// ======= imported  all products images from images folder ========
import pizzaImg01 from "../images/pizza1.png";
import pizzaImg02 from "../images/pizza2.png";
import pizzaImg03 from "../images/pizza3.jpg";
import pizzaImg04 from "../images/pizza4.jpg";
import pizzaImg05 from "../images/pizza5.jpg";
import pizzaImg06 from "../images/pizza6.png";
import pizzaImg07 from "../images/pizza7.png";
import pizzaImg08 from "../images/pizza8.jpg";

import fastFood02 from "../images/fastFood02.png";
import fastFood03 from "../images/fastFood03.png";
import fastFood04 from "../images/fastFood04.png";
import fastFood05 from "../images/fastFood05.png";
import fastFood06 from "../images/fastFood06.png";
import fastFood07 from "../images/fastFood07.png";
import fastFood08 from "../images/fastFood08.png";

import dessert02 from "../images/dessert02.png";
import dessert03 from "../images/dessert2.png";
import dessert04 from "../images/dessert3.png";
import dessert05 from "../images/dessert03.png";
import dessert06 from "../images/dessert04.png";
import dessert07 from "../images/dessert05.png";
import dessert08 from "../images/dessert06.png";

import coffeeImg02 from "../images/coffe2.png";
import coffeeImg03 from "../images/coffe3.png";
import coffeeImg04 from "../images/coffe4.png";
import coffeeImg05 from "../images/coffe5.png";
import coffeeImg06 from "../images/coffe6.png";
import coffeeImg07 from "../images/coffe7.png";
import coffeeImg08 from "../images/coffe8.png";

import riceImg01 from "../images/rice01.png";
import riceImg02 from "../images/rice02.png";
import riceImg03 from "../images/rice03.png";
import riceImg04 from "../images/rice04.png";
import riceImg05 from "../images/rice05.png";
import riceImg06 from "../images/rice06.png";
import riceImg07 from "../images/rice07.png";
import riceImg08 from "../images/rice08.png";

export const popularMenuFood = [
  {
    id: "01",
    title: "Vegetable Salad",
    price: 25,
    imgUrl: fastFood03,
  },
  {
    id: "02",
    title: "Chicken",
    price: 250,
    imgUrl: fastFood04,
  },

  {
    id: "03",
    title: "Whipped Cream",
    price: 45,
    imgUrl: dessert02,
  },

  {
    id: "04",
    title: "Pizza",
    price: 75,
    imgUrl: pizzaImg01,
  },
];

export const fastFoodProducts = [
  {
    id: "05",
    title: "Burger",
    price: 95,
    imgUrl: fastFood02,
  },
  {
    id: "06",
    title: "Chicken",
    price: 250,
    imgUrl: fastFood03,
  },
  {
    id: "07",
    title: "Grill Chicken",
    price: 195,
    imgUrl: fastFood04,
  },
  {
    id: "08",
    title: "Barbeque",
    price: 275,
    imgUrl: fastFood05,
  },
  {
    id: "09",
    title: "Pizza",
    price: 275,
    imgUrl: fastFood06,
  },
  {
    id: "10",
    title: "Burger",
    price: 95,
    imgUrl: fastFood07,
  },
  {
    id: "11",
    title: "Chicken",
    price: 250,
    imgUrl: fastFood08,
  },
  {
    id: "12",
    title: "Grill Chicken",
    price: 195,
    imgUrl: pizzaImg08,
  },
];

export const riceMenuProducts = [
  {
    id: "12",
    title: "Fried Rice",
    price: 95,
    imgUrl: riceImg01,
  },
  {
    id: "14",
    title: "Vegetable",
    price: 250,
    imgUrl: riceImg02,
  },
  {
    id: "15",
    title: "Vegetable Salad",
    price: 195,
    imgUrl: riceImg03,
  },
  {
    id: "16",
    title: "Meal",
    price: 275,
    imgUrl: riceImg04,
  },
  {
    id: "17",
    title: "Fried Rice",
    price: 95,
    imgUrl: riceImg05,
  },
  {
    id: "18",
    title: "Vegetable",
    price: 250,
    imgUrl: riceImg06,
  },
  {
    id: "19",
    title: "Vegetable Salad",
    price: 195,
    imgUrl: riceImg07,
  },
  {
    id: "20",
    title: "Meal",
    price: 275,
    imgUrl: riceImg08,
  },
];

export const dessertProducts = [
  {
    id: "21",
    title: "Whipped Cream",
    price: 50,
    imgUrl: dessert05,
  },
  {
    id: "22",
    title: "Cake Cream",
    price: 50,
    imgUrl: dessert02,
  },
  {
    id: "23",
    title: "Cake",
    price: 50,
    imgUrl: dessert08,
  },
  {
    id: "24",
    title: "Cup Cake",
    price: 275,
    imgUrl: dessert06,
  },
  {
    id: "25",
    title: "Whipped Cream",
    price: 50,
    imgUrl: dessert07,
  },
  {
    id: "26",
    title: "Cake Cream",
    price: 50,
    imgUrl: dessert02,
  },
  {
    id: "27",
    title: "Cake",
    price: 50,
    imgUrl: dessert03,
  },
  {
    id: "28",
    title: "Cup Cake",
    price: 275,
    imgUrl: dessert04,
  },
];

export const pizzaProducts = [
  {
    id: "29",
    title: "Pizza",
    price: 95,
    imgUrl: pizzaImg01,
  },
  {
    id: "30",
    title: "Pizza",
    price: 95,
    imgUrl: pizzaImg02,
  },
  {
    id: "31",
    title: "Pizza",
    price: 95,
    imgUrl: pizzaImg03,
  },
  {
    id: "32",
    title: "Pizza",
    price: 95,
    imgUrl: pizzaImg04,
  },
  {
    id: "33",
    title: "Pizza",
    price: 95,
    imgUrl: pizzaImg05,
  },
  {
    id: "34",
    title: "Pizza",
    price: 95,
    imgUrl: pizzaImg06,
  },

  {
    id: "35",
    title: "Pizza",
    price: 95,
    imgUrl: pizzaImg07,
  },
  {
    id: "36",
    title: "Pizza",
    price: 95,
    imgUrl: pizzaImg08,
  },
];

export const coffeeProducts = [
  {
    id: "37",
    title: "Hot Coffee",
    price: 20,
    imgUrl: coffeeImg07,
  },
  {
    id: "38",
    title: "Cold Coffee",
    price: 20,
    imgUrl: coffeeImg04,
  },
  {
    id: "39",
    title: "Black Coffee",
    price: 20,
    imgUrl: coffeeImg03,
  },
  {
    id: "40",
    title: "White Coffee",
    price: 95,
    imgUrl: coffeeImg06,
  },
  {
    id: "41",
    title: "Hot Coffee",
    price: 20,
    imgUrl: coffeeImg02,
  },
  {
    id: "42",
    title: "Cold Coffee",
    price: 20,
    imgUrl: coffeeImg08,
  },

  {
    id: "43",
    title: "Black Coffee",
    price: 20,
    imgUrl: coffeeImg05,
  },
  {
    id: "44",
    title: "White Coffee",
    price: 95,
    imgUrl: coffeeImg03,
  },
];
